export const SYSTEM_TRACE_TOKENS = [
  'mode=', 'intent=', 'source=', 'provider_status', 'profile=', 'tokens≈',
  'goal=', 'waiting_for=', 'provider_route=',
];
export const PROVIDER_TRACE_TOKENS = ['dashscope/', 'qwen-', 'gpt-', 'provider_status=ok'];

const REDACTED_TRACE_TOKENS = [...SYSTEM_TRACE_TOKENS, ...PROVIDER_TRACE_TOKENS];
const MODE_DETAIL_LABELS = {
  requirement_intake: '需求梳理',
  analysis_mode: '需求分析',
  intelligent_sourcing: '智能寻源',
};
const INTERNAL_DETAIL_REPLACEMENTS = [
  [/structured_package updated:[^\n|。.]*/gi, '需求字段结构已更新'],
  [/Update structured_package draft/gi, '更新需求字段结构'],
  [/环节完成:\s*canvas_state/gi, '需求结构已同步'],
  [/执行环节:\s*canvas_state/gi, '同步需求结构'],
];

const normalizeText = (value = '') => String(value || '').trim();
const normalizeLower = (value = '') => normalizeText(value).toLowerCase();
const toLines = (value = '') => String(value || '')
  .split('\n')
  .map(normalizeText)
  .filter(Boolean);

export function formatExecutionDetail(detail = '') {
  return toLines(detail)
    .filter((line) => !REDACTED_TRACE_TOKENS.some((token) => normalizeLower(line).includes(token)))
    .map((line) => {
      let nextLine = line.replace(/进入\s+default[。.]?/gi, '进入下一步。');
      Object.entries(MODE_DETAIL_LABELS).forEach(([modeKey, label]) => {
        nextLine = nextLine.replace(new RegExp(`进入\\s+${modeKey}[。.]?`, 'gi'), `进入${label}。`);
        nextLine = nextLine.replace(new RegExp(modeKey, 'gi'), label);
      });
      INTERNAL_DETAIL_REPLACEMENTS.forEach(([pattern, replacement]) => {
        nextLine = nextLine.replace(pattern, replacement);
      });
      return nextLine.replace(/\s+/g, ' ');
    })
    .join('\n');
}
